import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20fashion%20editorial%20atmospheric%20background%20with%20flowing%20deep%20burgundy%20and%20gold%20fabric%20textures%2C%20abstract%20artistic%20composition%2C%20warm%20lighting%20with%20dark%20shadows%2C%20luxury%20fashion%20vibe%2C%20minimalist%20aesthetic%2C%20cream%20and%20dark%20gradient%20background&width=1920&height=800&seq=cta-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/80"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-6 leading-tight">
          你准备好释放<br />
          <span className="text-accent-400">内心的野兽</span>了吗？
        </h2>
        <p className="text-background-200 text-base md:text-lg max-w-lg mx-auto leading-relaxed mb-10">
          不再隐藏，不再妥协。穿上你的战袍，让世界看见你真正的样子。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/categories"
            className="px-8 py-3.5 bg-accent-500 text-foreground-950 font-semibold text-sm tracking-wider rounded-md hover:bg-accent-400 transition-all duration-300 whitespace-nowrap"
          >
            开始探索风格
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 border border-background-300/50 text-background-50 font-medium text-sm tracking-wider rounded-md hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap"
          >
            了解品牌故事
          </Link>
        </div>
      </div>
    </section>
  );
}